import { Routes } from '@angular/router';
import { authGuard } from './core/http/auth.guard';
import { FlowDefinitionComponent } from './pages/flow-definition/flow-definition.component';
import { FlowInstanceComponent } from './pages/flow-instance/flow-instance.component';
import { ErrorComponent } from './core/error/error.component';
import { TestsComponent } from './pages/tests/tests.component';
import { Enums } from './shared/enums';
import { MjolnirComponent } from './pages/mjolnir/mjolnir.component';
import { EulaComponent } from './pages/eula/eula.component';
import { ShellDefaultComponent } from './pages/shell-default/shell-default.component';
import { ShellEmbedComponent } from './pages/shell-embed/shell-embed.component';
import { LoadingPageComponent } from './pages/loading-page/loading-page.component';
import { ShellEDocsComponent } from './pages/shell-edocs/shell-edocs.component';

const mainRoutes: Routes = [
    {
        path: '',
        component: ShellDefaultComponent,
        children: [
            {
                path: Enums.PagesPaths.Home.slice(1),
                component: LoadingPageComponent,
                canActivate: [() => {
                    const splittedPath = window.location.href.split('/').filter(x => x != '');
                    const splittedDomain = splittedPath[1].split(':')[0].split('.').filter(x => x != '');

                    if (splittedDomain.includes('localhost') || splittedDomain.includes('dev')) {
                        window.location.replace('https://e-docs.dev.es.gov.br/eflow/novo');
                    } else if (splittedDomain.includes('hom')) {
                        window.location.replace('https://e-docs.hom.es.gov.br/eflow/novo');
                    } else if (splittedDomain.includes('treinamento')) {
                        window.location.replace('https://treinamento.e-docs.es.gov.br/eflow/novo');
                    } else {
                        window.location.replace('https://e-docs.es.gov.br/eflow/novo');
                    }

                    return false;
                }],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            },
            {
                path: Enums.PagesPaths.FlowInstanceList.slice(1),
                component: LoadingPageComponent,
                canActivate: [() => {
                    const splittedPath = window.location.href.split('/').filter(x => x != '');
                    const splittedDomain = splittedPath[1].split(':')[0].split('.').filter(x => x != '');

                    if (splittedDomain.includes('localhost') || splittedDomain.includes('dev')) {
                        window.location.replace('https://e-docs.dev.es.gov.br/eflow/iniciados');
                    } else if (splittedDomain.includes('hom')) {
                        window.location.replace('https://e-docs.hom.es.gov.br/eflow/iniciados');
                    } else if (splittedDomain.includes('treinamento')) {
                        window.location.replace('https://treinamento.e-docs.es.gov.br/eflow/iniciados');
                    } else {
                        window.location.replace('https://e-docs.es.gov.br/eflow/iniciados');
                    }

                    return false;
                }],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            },
            {
                path: Enums.PagesPaths.FlowDefinitionList.slice(1),
                component: LoadingPageComponent,
                canActivate: [() => {
                    const splittedPath = window.location.href.split('/').filter(x => x != '');
                    const splittedDomain = splittedPath[1].split(':')[0].split('.').filter(x => x != '');

                    if (splittedDomain.includes('localhost') || splittedDomain.includes('dev')) {
                        window.location.replace('https://e-docs.dev.es.gov.br/eflow/novo');
                    } else if (splittedDomain.includes('hom')) {
                        window.location.replace('https://e-docs.hom.es.gov.br/eflow/novo');
                    } else if (splittedDomain.includes('treinamento')) {
                        window.location.replace('https://treinamento.e-docs.es.gov.br/eflow/novo');
                    } else {
                        window.location.replace('https://e-docs.es.gov.br/eflow/novo');
                    }

                    return false;
                }],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            },
            {
                path: `${Enums.PagesPaths.FlowDefinition.slice(1)}/:id`,
                component: FlowDefinitionComponent,
                canActivate: [authGuard],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            },
            {
                path: `${Enums.PagesPaths.FlowDefinition.slice(1)}/${Enums.PagesPaths.CatalogService.slice(1)}/:id`,
                component: FlowDefinitionComponent,
                canActivate: [authGuard],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            },
            {
                path: `${Enums.PagesPaths.FlowInstance.slice(1)}/:id`,
                component: FlowInstanceComponent,
                canActivate: [authGuard],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            },
            {
                path: `${Enums.PagesPaths.FlowInstanceResult.slice(1)}/:id`,
                component: FlowInstanceComponent,
                canActivate: [authGuard],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            },
            {
                path: `${Enums.PagesPaths.FlowInstance.slice(1)}/${Enums.PagesPaths.CatalogService.slice(1)}/:id`,
                component: FlowInstanceComponent,
                canActivate: [authGuard],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            },
            {
                path: Enums.PagesPaths.Error.slice(1),
                component: ErrorComponent,
                canActivate: [authGuard],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            },
            {
                path: Enums.PagesPaths.Eula.slice(1),
                component: EulaComponent,
                canActivate: [authGuard],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            },
            {
                path: Enums.PagesPaths.Tests.slice(1),
                component: TestsComponent,
                canActivate: [authGuard],
                data: { profiles: [Enums.Profiles.Owner] }
            },
            {
                path: `${Enums.PagesPaths.Mjolnir.slice(1)}/:id`,
                component: MjolnirComponent,
                canActivate: [authGuard],
                data: { profiles: [] }
            },
            {
                path: Enums.PagesPaths.LoadingPage.slice(1),
                component: LoadingPageComponent,
                canActivate: [authGuard],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            },
        ]
    },
];

const embedRoutes: Routes = [
    {
        path: `${Enums.PagesPaths.FlowDefinition.slice(1)}/:id/${Enums.PagesPaths.Embedded.slice(1)}`,
        component: ShellEmbedComponent,
        children: [
            {
                path: '',
                component: FlowDefinitionComponent,
                canActivate: [authGuard],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            }
        ],
    },
    {
        path: `${Enums.PagesPaths.FlowInstance.slice(1)}/:id/${Enums.PagesPaths.Embedded.slice(1)}`,
        component: ShellEmbedComponent,
        children: [
            {
                path: '',
                component: FlowInstanceComponent,
                canActivate: [authGuard],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            }
        ],
    },
    {
        path: `${Enums.PagesPaths.FlowInstanceResult.slice(1)}/:id/${Enums.PagesPaths.Embedded.slice(1)}`,
        component: ShellEmbedComponent,
        children: [
            {
                path: '',
                component: FlowInstanceComponent,
                canActivate: [authGuard],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            }
        ],
    },
];

const edocsRoutes: Routes = [
    {
        path: `${Enums.PagesPaths.FlowDefinition.slice(1)}/:id/${Enums.PagesPaths.Edocs.slice(1)}`,
        component: ShellEDocsComponent,
        children: [
            {
                path: '',
                component: FlowDefinitionComponent,
                canActivate: [authGuard],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            }
        ],
    },
    {
        path: `${Enums.PagesPaths.FlowDefinition.slice(1)}/:id/${Enums.PagesPaths.Edocs.slice(1)}/${Enums.PagesPaths.Origin.slice(1)}/:origin`,
        component: ShellEDocsComponent,
        children: [
            {
                path: '',
                component: FlowDefinitionComponent,
                canActivate: [authGuard],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            }
        ],
    },
    {
        path: `${Enums.PagesPaths.FlowInstance.slice(1)}/:id/${Enums.PagesPaths.Edocs.slice(1)}`,
        component: ShellEDocsComponent,
        children: [
            {
                path: '',
                component: FlowInstanceComponent,
                canActivate: [authGuard],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            }
        ],
    },
    {
        path: `${Enums.PagesPaths.FlowInstance.slice(1)}/:id/${Enums.PagesPaths.Edocs.slice(1)}/${Enums.PagesPaths.Origin.slice(1)}/:origin`,
        component: ShellEDocsComponent,
        children: [
            {
                path: '',
                component: FlowInstanceComponent,
                canActivate: [authGuard],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            }
        ],
    },
    {
        path: `${Enums.PagesPaths.FlowInstanceResult.slice(1)}/:id/${Enums.PagesPaths.Edocs.slice(1)}`,
        component: ShellEDocsComponent,
        children: [
            {
                path: '',
                component: FlowInstanceComponent,
                canActivate: [authGuard],
                data: { profiles: [] } /* array vazio para aceitar todos os perfis do AC */
            }
        ],
    },
];

const defaultRoute: Routes = [
    {
        path: '**',
        redirectTo: ''
    },
];

export const routes: Routes = mainRoutes.concat(embedRoutes).concat(edocsRoutes).concat(defaultRoute);
